// Client V1 imports
const airbrake = require('client/lib/airbrake')
const { send: ajax } = require('client/lib/request')
const { track } = require('client/lib/analytics')
// Common Client v2 imports
const { navigate } = require('client-v2/common/state/router/actions')

// Action enums

const USER_FOLLOWING_CHANGE_PENDING = 'USER_FOLLOWING_CHANGE_PENDING'

// Action types

const USER_FOLLOWING_CHANGE = 'USER_FOLLOWING_CHANGE'

// Action creators

function userFollowingChange(userId, isFollowing) {
  return {
    type: USER_FOLLOWING_CHANGE,
    payload: {
      userId,
      isFollowing
    }
  }
}

function userFollowingChangePending(userId) {
  return userFollowingChange(
    userId,
    USER_FOLLOWING_CHANGE_PENDING
  )
}

// Action dispatchers


function showUserActionsModal({ user, pageContext }) {
  // Mitigate circular dependency
  const clientV1Bridge = require('client-v2/common/client-v1-bridge')
  return function (dispatch, getState) {
    clientV1Bridge.showUserActionsModal({
      reportedUser: user,
      reporterUser: getState().user,
      pageContext
    })
  }
}

function showUserShareModal({ user }) {
  // Mitigate circular dependency
  const clientV1Bridge = require('client-v2/common/client-v1-bridge')
  return function () {
    clientV1Bridge.showUserShareModal({ shareUser: user })
  }
}

function toggleFollowing({ user, pageContext }) {
  return function (dispatch) {
    const toggledFollowing = !user.isFollowing
    const action = toggledFollowing ? 'follow' : 'unfollow'
    const method = toggledFollowing ? 'post' : 'delete'
    dispatch(userFollowingChangePending(user.id))
    ajax({
      url: `/api/v0.1/friends/${user.id}`,
      method
    })
    .then(() =>
      track(`${action}-person`, {
        'user_id': user.id,
        metabase: {
          'actioned_object_type': 'user',
          'actioned_object_id': user.id
        },
        'page_context': pageContext
      })
    )
    .then(() => {
      dispatch(userFollowingChange(user.id, toggledFollowing))
    })
    .catch(err => airbrake.notify(err))
  }
}

// Helpers

function navigateToUserHref(hrefFunc) {
  // Creates a navigation action dispatcher from a href helper function
  return function ({ event, user }) {
    return function (dispatch) {
      dispatch(navigate({
        event,
        href: hrefFunc(user)
      }))
    }
  }
}

function userProfileHref(user) {
  return `/${user.username}`
}

function userProfileCollectionsHref(user) {
  return `${userProfileHref(user)}/collections`
}

function userProfileCollectionsCreatedHref(user) {
  return `${userProfileCollectionsHref(user)}/created`
}

function userProfileCollectionsSubscribedHref(user) {
  return `${userProfileCollectionsHref(user)}/subscribed`
}

function userProfilePostsHref(user) {
  return `${userProfileHref(user)}/posts`
}

function userProfileFollowersHref(user) {
  return `${userProfileHref(user)}/followers`
}

function userProfileFollowingHref(user) {
  return `${userProfileHref(user)}/following`
}

module.exports = {
  // Enums
  USER_FOLLOWING_CHANGE_PENDING,
  // Types
  USER_FOLLOWING_CHANGE,
  // Dispatchers
  showUserActionsModal,
  showUserShareModal,
  toggleFollowing,
  // Helpers
  userProfileHref,
  userProfileCollectionsHref,
  userProfileCollectionsCreatedHref,
  userProfileCollectionsSubscribedHref,
  userProfileFollowersHref,
  userProfileFollowingHref,
  userProfilePostsHref
}

// Define navigation dispatchers
Object.entries({
  navigateToUserProfile: userProfileHref,
  navigateToUserProfileCollections: userProfileCollectionsHref,
  navigateToUserProfileCollectionsCreated: userProfileCollectionsCreatedHref,
  navigateToUserProfileCollectionsSubscribed: userProfileCollectionsSubscribedHref,
  navigateToUserProfileFollowers: userProfileFollowersHref,
  navigateToUserProfileFollowing: userProfileFollowingHref,
  navigateToUserProfilePosts: userProfilePostsHref
}).forEach(([ key, value ]) => {
  module.exports[key] = navigateToUserHref(value)
})
